// import React, {useState, useEffect, useRef} from 'react';
// import { Link } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import './MarketplaceNavbar.css'
// import logo from "../assets/ekalakar.png";
// import { RxAvatar } from "react-icons/rx";
// import { FiSearch } from "react-icons/fi";
// import LoginDropdown from './LoginDropdown';

// const Navbar = () => {
//   const [isLogin, setLogin] = useState(false)
//   const {token } = useSelector(state => state.auth);
//   const id = localStorage.getItem('artId');
//   const user = localStorage.getItem("name");
//   const searchRef = useRef();
//   const cartItemCount = useSelector((state) =>
//     state.cart.cartItems.length
//   );

//   useEffect(()=>{
//     if(id && id !== "undefined"){
//       setLogin(true);
//     }
//   }, [])

//   return (
//     <nav className="marketplace-navbar">
//       <div className="marketplace-navbar-container">
//         <Link className="navbar-brand" to="/">
//           <img src={logo} alt="ekalakaar-logo" />
//         </Link>

//         {/* <button
//           className="navbar-toggler"
//           type="button"
//           data-bs-toggle="collapse"
//           data-bs-target="#navbarNav"
//           aria-controls="navbarNav"
//           aria-expanded="false"
//           aria-label="Toggle navigation"
//         >
//           <span className="navbar-toggler-icon"></span>
//         </button> */}

//         <div className="navbar-items" id="navbarNav">
//           <ul className="nav-list">
//             <li className="nav-item">
//               <Link className="nav-link" to="/marketplace">
//                 Home
//               </Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/my-orders">
//                 My Orders
//               </Link>
//             </li>

//             {/* <div className='searchbar-marketplace'>
//               <FiSearch />
//               <input type='text' onChange={searchRef} />
//             </div> */}
//             {/* Add other nav items as needed */}
//           </ul>

//           <ul className="nav-list-cart">
//             <li className="nav-item">
//               <Link className="nav-link position-relative" to="/cart-view">
//                 <i className="fas fa-shopping-cart"></i> Cart
//                 {/* {cartItemCount > 0 && (
//                   <span className="badge bg-primary position-absolute top-0 start-100 translate-middle">
//                   {cartItemCount}
//                   </span>
//                   )} */}
//               </Link>
//             </li>
//             <li className="nav-item">
//               {
//                 isLogin ? user : <LoginDropdown />
//               }
//             </li>
//           </ul>
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;



import React, {useState, useEffect, useRef} from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import './MarketplaceNavbar.css'
import logo from "../assets/ekalakar.png";
import { RxAvatar } from "react-icons/rx";
import { FiSearch } from "react-icons/fi";
import LoginDropdown from './LoginDropdown';

const Navbar = () => {
  const [isLogin, setLogin] = useState(false)
  const {token } = useSelector(state => state.auth);
  const id = localStorage.getItem('artId');
  const user = localStorage.getItem("name");
  const searchRef = useRef();
  const cartItemCount = useSelector((state) =>
    state.cart.cartItems.length
  );

  useEffect(()=>{
    if(id && id !== "undefined"){
      setLogin(true);
    }
  }, [])

  return (
    <nav className="marketplace-navbar">
      <div className="marketplace-navbar-container">
        <Link className="navbar-brand" to="/">
          <img src={logo} alt="ekalakaar-logo" />
        </Link>

        {/* <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button> */}

        <div className="navbar-items" id="navbarNav">
          <ul className="nav-list">
            <li className="nav-item">
              <Link className="nav-link" to="/marketplace">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/partner-products">
                Partner Products
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/partner-services">
                Partner Services
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/my-orders">
                My Orders
              </Link>
            </li>

            {/* <div className='searchbar-marketplace'>
              <FiSearch />
              <input type='text' onChange={searchRef} />
            </div> */}
            {/* Add other nav items as needed */}
          </ul>

          <ul className="nav-list-cart">
            <li className="nav-item">
              <Link className="nav-link position-relative" to="/cart-view">
                <i className="fas fa-shopping-cart"></i> Cart
                {/* {cartItemCount > 0 && (
                  <span className="badge bg-primary position-absolute top-0 start-100 translate-middle">
                  {cartItemCount}
                  </span>
                  )} */}
              </Link>
            </li>
            <li className="nav-item">
              {
                isLogin ? user : <LoginDropdown />
              }
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;